import React, { useState } from 'react';

import {
    AccordionAnimate,
    AccordionAnimateBody,
    AccordionAnimateHeader,
} from '@r1-frontend/ui-react/components/accordions/AccordionAnimate';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import { ListItem } from '../list/styled';
import { ProblemList } from '../styled';

import * as ST from './styled';

type IItemInnerContent = {
    title: string,
    desc: string,
}

export interface IMultiLevelAccordionFAQ {
    ask: string,
    desc: string,
    content: Array<IItemInnerContent>,
}

const MultiLevelAccordionFAQ = ({ ask, desc, content }: IMultiLevelAccordionFAQ): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);
    const onToggleHandler = (status: boolean) => setIsOpen(status);
    return (
        <AccordionAnimate isAnimate={true} duration={1} onToggle={onToggleHandler}>
            <AccordionAnimateHeader>
                <ST.Ask isOpen={isOpen}>{ask}</ST.Ask>
            </AccordionAnimateHeader>
            <AccordionAnimateBody>
                <Paragraph4 style={{ marginTop: '15px' }}>{desc}</Paragraph4>
                <ST.Response>
                    {content.map(item => <ProblemList key={item.title}>
                        <ListItem>
                            <ST.Li>
                                {item.title}
                            </ST.Li>
                        </ListItem>
                        <Paragraph4 dangerouslySetInnerHTML={{ __html: item.desc }} />
                    </ProblemList>)}
                </ST.Response>
            </AccordionAnimateBody>
        </AccordionAnimate>
    );
};

export default MultiLevelAccordionFAQ;
